<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
    />
    <path d="M 9 9.4 A 3 3 0 0 1 15 9.4 A 3 3 0 0 1 12 12.4 L 12 13.4" />
    <line
      x1="12"
      y1="16.4"
      x2="12"
      y2="16.4"
      stroke-width="2.5"
    />
  </svg>
</template>
